import gql from "graphql-tag";

export const FEATURE_LOGO_ROW_FRAGMENT = gql`
fragment featureLogoRowFragment on featureLogoRow {
    sectionIntro {
      content
      title
    }
  }
  `;